const rules = [];
const attributes = [];

const addRule = (attributeName, rule) => {
  if (!attributeName) {
    throw new Error('attribute name is required for CSS Generator rule');
  }

  if (!Array.isArray(rule)) {
    throw new Error('Rule for CSS Generator must be an array');
  }

  if (attributes.includes(attributeName)) {
    throw new Error('attribute name already exists in CSS Generator rules');
  }

  rules.push(rule);
  attributes.push(attributeName);
};

const getRules = () => rules;
const getAttributes = () => attributes;

export { addRule, getRules, getAttributes };
